// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"852":"0bdb9c4a7c2591aa","4804":"d1d43ccf60793d2d"}[chunkId] + ".css";
};